module.exports = __webpack_public_path__ + "media/applicants/left-arrow-712e607d.svg";